import { render, staticRenderFns } from "./CustomFormEditor.vue?vue&type=template&id=8ab2192a&scoped=true"
import script from "./CustomFormEditor.vue?vue&type=script&lang=js"
export * from "./CustomFormEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomFormEditor.vue?vue&type=style&index=0&id=8ab2192a&prod&lang=scss&scoped=true"
import style1 from "./CustomFormEditor.vue?vue&type=style&index=1&id=8ab2192a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab2192a",
  null
  
)

export default component.exports